export default {
      id: "frame-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "sprite.svg#frame",
      toString: function () {
        return this.url;
      }
    }